import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { AdvancedSection } from "@/modules/shell/AdvancedSection";

/** Collapsed doc tax override — plan/31 / plan/13 / plan/34 */
export function TaxAdvancedFields(props: {
  orgTaxPriceMode: "inclusive" | "exclusive" | string;
  orgTaxRatePct: string;
  taxPriceMode: "" | "inclusive" | "exclusive";
  taxRatePct: string;
  onTaxPriceMode: (v: "" | "inclusive" | "exclusive") => void;
  onTaxRatePct: (v: string) => void;
}) {
  const {
    orgTaxPriceMode,
    orgTaxRatePct,
    taxPriceMode,
    taxRatePct,
    onTaxPriceMode,
    onTaxRatePct,
  } = props;
  const orgRateLabel = String(Number(orgTaxRatePct));

  return (
    <AdvancedSection subtitle="tax" className="mt-4">
      <p className="m-0 text-xs text-[var(--color-muted)]">
        Org default: {orgRateLabel}% {orgTaxPriceMode}. Leave blank to keep it.
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <Label htmlFor="tax-price-mode">Tax price mode</Label>
          <Select
            id="tax-price-mode"
            className="mt-1"
            value={taxPriceMode}
            onChange={(e) =>
              onTaxPriceMode(
                e.target.value as "" | "inclusive" | "exclusive",
              )
            }
          >
            <option value="">Org default ({orgTaxPriceMode})</option>
            <option value="inclusive">Inclusive</option>
            <option value="exclusive">Exclusive</option>
          </Select>
        </div>
        <div>
          <Label htmlFor="tax-rate-pct">Tax rate %</Label>
          <Input
            id="tax-rate-pct"
            className="mt-1 font-mono"
            inputMode="decimal"
            value={taxRatePct}
            onChange={(e) => onTaxRatePct(e.target.value)}
            placeholder={orgRateLabel}
          />
        </div>
      </div>
    </AdvancedSection>
  );
}
